import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=ed502e5a&scoped=true"
import script from "./Noticia.vue?vue&type=script&lang=js"
export * from "./Noticia.vue?vue&type=script&lang=js"
import style0 from "./Noticia.vue?vue&type=style&index=0&id=ed502e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed502e5a",
  null
  
)

export default component.exports